<template functional>
  <el-popover
    placement="top-start"
    trigger="click"
    title="Danh sách: "
    transition="el-zoom-in-bottom"
  >
    <!-- 2 case: dataJson is array and dataJson is object people response -->
    <el-table
      v-if="Array.isArray(props.action.dataJson)"
      :data="props.action.dataJson || []"
      style="width: 100%"
      stripe
      max-height="400"
      :show-header="false"
      size="mini"
    >
      <el-table-column
        type="index"
        width="40"
      >
      </el-table-column>
      <el-table-column
        label="Họ tên"
        width="350"
        show-overflow-tooltip
      >
        <template slot-scope="scope">
          <span
            v-if="props.categoryVBan === 'doc-in'"
            class="padding-0 margin-0"
          >
            <span class="font-weight__bold font-size__small">
              {{
              props.actionName == "chuyenXuLiDonVi"
              ? scope.row.toDeptName || scope.row.deptReceiverName
              : props.actionName == "chuyenXuLi" || props.actionName == "cc"
              ? `${scope.row.receiverName} - ${scope.row.receiverPosName} - ${scope.row.deptReceiverName}`
              : props.actionName == "thuHoi"
              ? scope.row.receiverName || scope.row.deptReceiverName
              : props.actionName == "banHanh"
              ? scope.row.deptName
              : ""
              }}
            </span>
            <span class="font-italic">
              {{ (props.actionName == 'chuyenXuLiDonVi' || props.actionName == 'chuyenXuLi') ? parent.getProcessTypeName(scope.row.processType) : '' }}
            </span>
          </span>
          <span
            v-else-if="props.categoryVBan === 'doc-out'"
            class="padding-0 margin-0"
          >
            <span class="font-weight__bold font-size__small">
              {{
              props.actionName == "thuHoiBanHanh" ||
              props.actionName == "banHanh" ||
              props.actionName == "hieuChinhBanHanh"
              ? scope.row.toDeptName || scope.row.deptName
              : props.actionName == "banHanhCaNhan" ||
              props.actionName == "cc" ||
              props.actionName == "hieuChinhBanHanhCaNhan"
              ? `${scope.row.receivedName} - ${scope.row.positionName}`
              : ""
              }}
            </span>
          </span>
        </template>
      </el-table-column>
    </el-table>
    <div v-else>
      <p class="select-signer">
        <span>1.</span>
        <span>
          <span
            v-if="props.categoryVBan === 'doc-in'"
            class="font-weight__bold"
          >
            <span class="font-weight__bold font-size__small">
              {{
              props.actionName == "chuyenXuLi"
              ? `${props.action.dataJson.receiverName} - ${props.action.dataJson.receiverPosName} - ${props.action.dataJson.deptReceiverName}` : ""
              }}
            </span>
            <span class="font-italic">
              {{ (props.actionName == 'chuyenXuLiDonVi' || props.actionName == 'chuyenXuLi') ? parent.getProcessTypeName(item.processType) : '' }}
            </span>
          </span>
          <span
            v-else-if="props.categoryVBan === 'doc-out'"
            class="font-weight__bold font-size__small"
          >
            {{
            props.actionName == "chuyenXuLi" ||
            props.actionName == "kySoChuyenXuLi"
            ? `${props.action.dataJson.receiverName} - ${props.action.dataJson.receiverPosName} - ${props.action.dataJson.deptReceiverName}` : ""
            }}
          </span>
        </span>
      </p>
    </div>
    <span slot="reference">
      <i class="fas fa-info-circle color__yellow"></i>
    </span>
  </el-popover>
</template>

<script>
  export default {
    props: {
      action: {
        type: Object,
        default: () => {
          return {};
        }
      },
      actionName: {
        type: String,
        default: ""
      },
      categoryVBan: {
        type: String,
        default: ""
      }
    }
  };
</script>

<style lang="css" scoped></style>



// WEBPACK FOOTER //
// src/views/doc-in/doc-in-receivers-info.vue